import { inject, Injectable } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomDateAdapter extends LuxonDateAdapter {
  private readonly _translate = inject(TranslateService);

  override getDayOfWeekNames(): string[] {
    const translations = [
      'general.labels.sundayShort',
      'general.labels.mondayShort',
      'general.labels.tuesdayShort',
      'general.labels.wednesdayShort',
      'general.labels.thursdayShort',
      'general.labels.fridayShort',
      'general.labels.saturdayShort',
    ];

    return translations.map(key => this._translate.instant(key));
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'short') {
      const translations = [
        'general.labels.januaryShort',
        'general.labels.februaryShort',
        'general.labels.marchShort',
        'general.labels.aprilShort',
        'general.labels.mayShort',
        'general.labels.juneShort',
        'general.labels.julyShort',
        'general.labels.augustShort',
        'general.labels.septemberShort',
        'general.labels.octoberShort',
        'general.labels.novemberShort',
        'general.labels.decemberShort',
      ];

      return translations.map(key => this._translate.instant(key));
    }

    return super.getMonthNames(style);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  override format(date: Date, display: string): string {
    if (!date) return '';

    const isPeriodLabelFormat =
      display && typeof display === 'object' && Object.keys(display).length === 2;

    if (isPeriodLabelFormat) {
      const monthKey = this._monthNumberToKey(date.getMonth());
      const month = this._translate.instant(`general.labels.${monthKey}Short`);
      const year = date.getFullYear();

      return `${month} ${year}`;
    }

    return super.format(date, display);
  }

  override getFirstDayOfWeek(): number {
    // Return 1 for Monday, 0 for Sunday, etc.
    // This prevents the Intl.Locale error
    return 1; // Monday as first day of week
  }

  private _monthNumberToKey(monthNum: number): string {
    const keys = [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ];

    return keys[monthNum];
  }
}
